import React from 'react'
import { connect } from 'react-redux'
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import queryString from 'query-string';
import DoctorConfirmation from './DoctorConfirmation';
import "../PaymentStatusPage/ThankyouCart.css";

const index = () => {

  const location = useLocation()
  const { slug } = useParams()
  const parsed = queryString.parse(location.search);

  // console.log(parsed,slug,"<<<<")

  return (
    <>
      <DoctorConfirmation parsed={parsed} id={slug}/>
    </>
  )
}
 
const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default {
    component: connect(mapStateToProps, mapDispatchToProps)(index),
};